module.exports = __webpack_public_path__ + "img/Scheduling.7fa4ef6e.png";